/**
 * @changelog
 *
 *
 * 2026-02-28 (0.1.0) (jhoward)
 *   - Add /offers/:offerDomain/:offerCode/view route for viewing offer details.
 *
 * 2026-03-11 (0.1.1) (jhoward)
 *   - Add 'pageTitle' and 'twoFactorAuthRequired' meta fields to 'offers.view' route.
 *
 * 2026-03-17 (0.2.0) (jhoward)
 *   - Add /offers/refresh route for development/staging/local environments.
 *
 * 2026-03-24 (0.3.0) (jhoward)
 *   - Remove /offers/refresh route for local, staging, development environments.
 */

import type { RouteRecordRaw } from 'vue-router';
import ViewOffer from '@/views/Offers/ViewOffer.vue';

const offerRoutes: RouteRecordRaw[] = [
  {
    path: '/offers/:offerDomain/:offerCode/view',
    name: 'offers.view',
    component: ViewOffer,
    meta: {
      pageTitle: 'View Offer',
      authRequired: true,
      twoFactorAuthRequired: true,
    },
    props: true,
  },
];

export default offerRoutes;
